export const PERMISSIONS = {
  PLAY: 1,
  ADMIN: 2,
  UPDATE: 4,
  DELETE: 8,
  TOKEN_TRANSFER: 16,
  TOKEN_INFUSE: 32,
  TOKEN_MIGRATE: 64,
  TOKEN_DEFUSE: 128,
  SOURCE_ALLOCATION: 256,
  GUILD_MEMBERSHIP: 512,
  SUBSTATION_CONNECTION: 1024,
  ALLOCATION_CONNECTION: 2048,
  GUILD_TOKEN_BURN: 4096,
  GUILD_TOKEN_MINT: 8192,
  GUILD_ENDPOINT_UPDATE: 16384,
  GUILD_JOIN_CONSTRAINTS_UPDATE: 32768,
  GUILD_SUBSTATION_UPDATE: 65536,
  PROVIDER_WITHDRAW: 131072,
  PROVIDER_OPEN: 262144,
  REACTOR_GUILD_CREATE: 524288,
  HASH_BUILD: 1048576,
  HASH_MINE: 2097152,
  HASH_REFINE: 4194304,
  HASH_RAID: 8388608,
  GUILD_UGC_UPDATE: 16777216,

  ASSETS_ALL: 16 | 32 | 64 | 128,
  HASH_ALL: 1048576 | 2097152 | 4194304 | 8388608,
  ALL: (1 << 25) - 1,
};
